import { render, staticRenderFns } from "./song-correction-show.vue?vue&type=template&id=47d9635e&"
import script from "./song-correction-show.vue?vue&type=script&lang=js&"
export * from "./song-correction-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports